var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoMoney = function SvgNoMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.845 12.367c-4.342-.92-4.661-2.888-4.661-3.96 0-1.227 1.049-3.907 4.902-3.907 2.598 0 4.115 1.301 4.971 2.808M15.665 13.8c1.16.824 1.508 1.869 1.392 3.166-.155 1.729-1.91 3.665-4.937 3.527-.965-.044-1.774-.228-2.455-.493M12 4V1.5M12 23.5V21M20 4.5l-16 16"
  }))));
};
export default SvgNoMoney;